import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    threshold: { type: Number, default: 10 }
  }

  connect() {
    this.lastScrollTop = 0
    this.scrollHandler = this.handleScroll.bind(this)
    window.addEventListener('scroll', this.scrollHandler, { passive: true })
  }

  disconnect() {
    window.removeEventListener('scroll', this.scrollHandler)
  }

  handleScroll() {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop
    
    // Scrolling down
    if (currentScrollTop > this.lastScrollTop && currentScrollTop > this.thresholdValue) {
      this.element.style.transform = 'translateY(-100%)'
      this.element.style.transition = 'transform 0.3s ease-in-out'
    } 
    // Scrolling up
    else if (currentScrollTop < this.lastScrollTop) {
      this.element.style.transform = 'translateY(0)'
      this.element.style.transition = 'transform 0.3s ease-in-out'
    }
    
    this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop
  }
}
